var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.fullcalendar = {
	calendar: null,
	options: null,
	init: function (element, options) {
		$(element).each(function() {
			let $this = $(this);
			let events = options.dates[$this.attr('data-month')];
			$this.fullCalendar({
				firstDay: 0,
				monthNames: options.language.monthNames,
				dayNamesShort: options.language.dayNamesShort,
				defaultDate: events[0].start,
				events: events,
				eventColor: '#048CF5',
				aspectRatio: 1.12,
				header: {
					left: 'title',
					center: '',
					right: ''
				},
				height: 393,
				contentHeight: "auto",
				displayEventTime: false,
			});
		});

	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {

		$('#stationOpeningToday').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();
			$('#stationOpeningTomorrow').removeClass('active');
			$(this).addClass('active');
			$('.extras__stations .openingHours .today').addClass('active');
			$('.extras__stations .openingHours .tomorrow').removeClass('active');
		});
		$('#stationOpeningTomorrow').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();
			$('#stationOpeningToday').removeClass('active');
			$(this).addClass('active');
			$('.extras__stations .openingHours .today').removeClass('active');
			$('.extras__stations .openingHours .tomorrow').addClass('active');
		});

		site.collectionFilter.init();
	}
};

site.collectionFilter = {
	collectionVal: '',
	collections: undefined,
	collectionsLink: undefined,

	init: function() {
		var $collections = $('.extras__front');
		if ($collections.length === 0) {
			return;
		}
		var $collectionFilter = $collections.find('#collectionFilter');
		site.collectionFilter.collections = $collections.find('.collections__dates .collection');
		site.collectionFilter.collectionsLink = $collections.find('.collections__link .link');
		site.collectionFilter.collectionVal = document.getElementById('collectionFilter').value;
		site.collectionFilter.updateVisibility();
		$collectionFilter.on('change', site.collectionFilter.handleCategoryChange);

		var $hash = location.hash.substr(1);
		if ($hash.length > 0) {
			site.collectionFilter.collectionVal  = $hash;
			site.collectionFilter.updateVisibility();
			document.getElementById('collectionFilter').value=$hash;
		}
	},

	handleCategoryChange: function() {
		site.collectionFilter.collectionVal = $(this).val();
		site.collectionFilter.updateVisibility();
	},

	updateVisibility: function() {
		var $colVal = site.collectionFilter.collectionVal;
		site.collectionFilter.collections.hide();
		site.collectionFilter.collectionsLink.hide();

		site.collectionFilter.collections.filter(function() {
				return $(this).is('.' + $colVal);
			}
		).show();
		site.collectionFilter.collectionsLink.filter(function() {
				return $(this).is('.' + $colVal);
			}
		).show();
	},
};

site.stations = {
	init: function () {
		if ($('.linked__items .linked__item').length === 0) {
			return false;
		}

		$('.linked__item').on('click', function(e) {
			e.stopPropagation();
			var $this = $(this),
				$linkedItem = $this;
			$linkedItem.siblings().removeClass('showContent');
			$linkedItem.toggleClass('showContent');
		});

		$('.content', '.linked__item').on('click', function(e) {
			e.stopPropagation();
		});

		$('body').on('click', function() {
			$('.linked__item', '.linked__items').removeClass('showContent');
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.stations.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.formbuilder')) {
		site.fileupload.init('#file');
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
